import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import "@/App.css";
import { Noise } from "@/components/Noise";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { MenuSection } from "@/components/Menu";
import { Location } from "@/components/Location";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    document.title = "Dal Conte — Pizzeria di Campagna · Villachiara (BS)";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App">
        <Noise />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <MenuSection />
          <Location />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
